
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'test',
	'visualizationSlideoutTitle': 'Visualisations',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Entrer un nombre',
	'maxValuePlaceholder': 'Entrer un nombre',
	'customRangeErrorMessage': 'La valeur doit être un nombre',
	'propFillColor': 'Couleur de remplissage',
	'propBorderColor': 'Couleur de la bordure',
	'propColorPalette': 'Palette de couleurs actuelle',
	'propColorPaletteChangeLabel': 'Modifier la palette de couleurs',
	'propNewColorPaletteLabel': 'Créer une palette de couleurs personnalisée',
	'propNewHeatPaletteLabel': 'Créer une palette de densités personnalisée',
	'propDonutRadius': 'Rayon de l\'anneau',
	'showTitleLabel': 'Afficher le titre',
	'titleTypeLabel': 'Type de titre',
	'smartTitleLabel': 'Titre intelligent',
	'customTitleLabel': 'Titre personnalisé',
	'noTitleLabel': 'Pas de titre',
	'propHeatScalePalette': 'Palette de densités actuelle',
	'propHeatPaletteChangeLabel': 'Modifier la palette de densités',
	'propMaintainAxisScales': 'Maintenir l\'échelle de l\'axe',
	'propLineAndSymbolColor': 'Couleur des lignes et des symboles',
	'propLineAndSymbolPalette': 'Palette de couleurs des lignes et des symboles',
	'propElementColor': 'Couleur de l\'élément',
	'propColumnColor': 'Couleur de la colonne',
	'propColumnPalette': 'Palette de couleurs de colonne',
	'propColumnHeatPalette': 'Palette de densités de colonne',
	'propBarColor': 'Couleur des barres',
	'propGoalColor': 'Couleur de la cible',
	'propToColor': 'Couleur d\'arrivée',
	'propFromColor': 'Couleur de départ',
	'propNumberValidationErrorMessageId': 'Entrer un nombre',
	'fontSizeAuto': 'Automatique',
	'propAutoBinCount': 'Nombre de groupes',
	'propAutoBinToggle': 'Regroupement automatique',
	'tabName_general': 'Général',
	'tabName_visDetails': 'Détails',
	'tabName_animation': 'Animation',
	'tabName_mediaDetails': 'Détails du support',
	'tabName_webDetails': 'Détails de la page Web',
	'tabName_imageDetails': 'Détails de l\'image',
	'tabName_visualization': 'Visualisation',
	'tabName_text': 'Texte',
	'sectionName_colorsAndThemes': 'Couleur et thèmes',
	'sectionName_appearance': 'Apparence',
	'sectionName_general': 'Général',
	'sectionName_colorPalette': 'Couleur',
	'sectionName_axis': 'Axe',
	'sectionName_axis_label': 'Axe',
	'sectionName_legend': 'Légende',
	'sectionName_chart': 'Graphique',
	'sectionName_regionLayer': 'Couche des régions',
	'sectionName_pointLayer': 'Couche des points',
	'sectionName_latLongLayer': 'Couche latitude/longitude',
	'sectionName_pathLayer': 'Couche de chemin d\'accès',
	'sectionName_xAxis': 'Axe des X',
	'sectionName_yAxis': 'Axe des Y',
	'sectionName_xAxis_title': 'Titre de l\'axe X',
	'sectionName_yAxis_title': 'Titre de l\'axe Y',
	'sectionName_xAxis_label': 'Libellé de l\'axe X',
	'sectionName_yAxis_label': 'Libellé de l\'axe Y',
	'sectionName_column_yAxis': 'Axe Y de la colonne',
	'sectionName_column_yAxis_label': 'Libellé de l\'axe Y de la colonne',
	'sectionName_column_yAxis_title': 'Titre de l\'axe Y de la colonne',
	'sectionName_line_yAxis': 'Axe Y de la ligne',
	'sectionName_line_yAxis_label': 'Libellé de l\'axe Y de la ligne',
	'sectionName_line_yAxis_title': 'Titre de l\'axe Y de la ligne',
	'sectionName_title': 'Titre',
	'sectionName_dataValueLabels': 'Libellés de valeurs',
	'sectionName_style': 'Style',
	'propTransparencyDescription': 'Rendez l\'objet plus ou moins transparent. Entrez une valeur comprise entre 0 et 100.',
	'smart_annotation_unauthorized': 'Annotations : accès non autorisé',
	'smart_annotation_method': 'Annotations : méthode non autorisée',
	'smart_annotation_media': 'Annotations : type de support non autorisé',
	'smart_annotation_input': 'Annotations : entrée non valide',
	'smart_annotation_internal': 'Annotations : erreur de système interne',
	'smart_annotation_generic_error': 'Annotations : erreur de service',
	'smart_annotation_dialog_title': 'Connaissances',
	'smart_annotation_Show_Insights': 'Afficher les connaissances',
	'smart_annotation_Relationship': 'La relation est',
	'forecast_enter_number': 'Entrer un nombre entre ',
	'and': ' et ',
	'smart_errors': 'Erreurs d\'annotation :',
	'smart_warnings': 'Avertissements d\'annotation :',
	'smart_annotation_insight_icon_title': 'Connaissances',
	'smart_annotations_toggle_on': 'Activer les connaissances',
	'smart_annotations_toggle_off': 'Désactiver les connaissances',
	'smart_annotation_toggle_on': 'Activer',
	'smart_annotation_toggle_off': 'Désactiver',
	'smart_annotation_insight_unavailable': 'Les connaissances sont actuellement indisponibles',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Les connaissances ne sont pas disponibles lorsqu\'un filtre % supérieur ou inférieur est appliqué',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Les prévisions ne sont pas disponibles lorsqu\'un filtre % supérieur ou inférieur est appliqué',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Les connaissances ne sont pas disponibles lorsqu\'un filtre supérieur ou inférieur est appliqué et qu\'il existe plusieurs colonnes dans la zone',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Les prévisions ne sont pas disponibles lorsqu\'un filtre supérieur ou inférieur est appliqué et qu\'il existe plusieurs colonnes dans la zone',
	'forecast_title': 'Prévision',
	'forecast_show': 'Afficher les prévisions',
	'forecast_toggle_on': 'Activer la prévision',
	'forecast_toggle_off': 'Désactiver la prévision',
	'statDetailsPerspectiveTitle': 'Analyse',
	'emptyStatDetailsPanel': 'Aucune analyse supplémentaire n\'est disponible pour la visualisation en cours.',
	'predict_errors': 'Erreurs d\'analyse',
	'predict_warnings': 'Avertissements d\'analyse',
	'fpd_invalid_data_source': 'Cette source de données n\'est associée à aucun module smarts',
	'fpd_network_issue': 'Un problème s\'est produit lors de l\'exécution de l\'analyse sur cette source de données',
	'fpd_data_source_category': 'Module smarts manquant',
	'fpd_response_errors': 'Erreurs de pilote recommandé',
	'fpd_response_warnings': 'Avertissements sur le pilote recommandé',
	'catalyst_service_bad_request': 'Demande erronée',
	'catalyst_service_unkown_Id': 'ID de demande inconnu trouvé',
	'catalyst_service_internal_server_error': 'Erreur interne du serveur',
	'catalyst_service_generic_error': 'Erreur du service Catalyst',
	'catalyst_service_error': 'Ce service n\'est pas disponible actuellement',
	'propLegendPosition': 'Position de la légende',
	'propLeft': 'A gauche',
	'propRight': 'A droite',
	'propTop': 'En haut',
	'propBottom': 'En bas',
	'propNone': 'Aucun',
	'propLegendDisplay': 'Afficher la légende',
	'targetThicknessPlaceHolder': 'Du %{min} au %{max}',
	'targetThicknessErrorMsg': 'Entrez un nombre entier compris entre %{min} et %{max}.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Pilotes (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'sélectionnés)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Restaurer les valeurs par défaut',
	'possibelKeyDriver_AddNewDrivers': 'Ajouter d\'autres pilotes',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Recherche pour ajouter d\'autres pilotes',
	'possibleKeyDrivers_MaxPossibleReached': 'Désélectionner des pilotes pour en ajouter ou en sélectionner d\'autres',
	'possibleKeyDrivers_Recommended': 'Recommandés',
	'visRecommendedTypes': 'Types de visualisation recommandés',
	'visRecommender_smartsfailure': 'les recommandations associées aux visualisations ne sont pas disponibles actuellement',
	'visMore': 'Plus...',
	'visMoreTooltip': 'Autres visualisations',
	'visOtherTypes': 'Autres types de visualisation',
	'visChange': 'Changer de visualisation',
	'automaticTypeCaption': 'Automatique',
	'propVisType': 'Types de visualisation',
	'dlg_loading': 'Chargement...',
	'snippetListChartCaption': 'Liste de fragments',
	'convoClusterChartCaption': 'Cluster de conversation',
	'areaChartCaption': 'Aire',
	'barChartCaption': 'Barres',
	'columnChartCaption': 'Colonne',
	'stackedbarChartCaption': 'Barre superposée',
	'stackedcolumnChartCaption': 'Colonne superposée',
	'bubbleChartCaption': 'Bulles',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Analyse du pilote',
	'scatterChartCaption': 'Nuage de points',
	'lineChartCaption': 'Courbe',
	'pointChartCaption': 'Points',
	'heatChartCaption': 'Carte de densité',
	'bulletChartCaption': 'Puce',
	'waterfallChartCaption': 'Graphique en cascade',
	'radarChartCaption': 'Radar',
	'boxplotChartCaption': 'Diagramme à surfaces',
	'pieChartCaption': 'Circulaire',
	'mapChartCaption': 'Carte',
	'radialBarChartCaption': 'Radial',
	'compositeChartCaption': 'Courbe et colonne',
	'wordCloudChartCaption': 'Nuage de mots',
	'networkChartCaption': 'Réseau',
	'relationshipNetworkChartCaption': 'Réseau de relations',
	'treemapChartCaption': 'Carte d\'arborescence',
	'packedBubbleChartCaption': 'Paquet de bulles',
	'hierarcicalPackedBubbleChartCaption': 'Bulle de hiérarchie',
	'spiralChartCaption': 'Spirale',
	'decisionTreeChartCaption': 'Arbre de décisions',
	'legacyMapChartCaption': 'Carte existante',
	'sunburstChartCaption': 'Rayons',
	'visUsageComparison': 'Comparaison',
	'visUsageRelationships': 'Relations',
	'visUsageTrend': 'Tendance',
	'visUsagePartsToWhole': 'De partie à tout',
	'visUsageGeospatial': 'Géospatial',
	'visUsageAdvanced': 'Analyse avancée',
	'visUsageTablesAndSummary': 'Tableaux et récapitulatif',
	'visUsageSocialInsights': 'Informations sociales',
	'visUsageOther': 'Autre',
	'autoBinActionText': 'Regrouper automatiquement',
	'filterAutobinActionText': 'Filtrer les casiers',
	'memberCalculationActionText': 'Calcul de membre',
	'toolbarActionCalculation': 'Créer un calcul',
	'toolbarActionEditCalculation': 'Editer le calcul',
	'topBottomRankLabel': 'Rang (%{label})',
	'toolbarDeleteFilterActionText': 'Retirer le filtre',
	'toolbarActionTopKeyDrivers': 'Afficher les pilotes',
	'toolbarActionCustomGroup': 'Groupe personnalisé',
	'canNotCreateCustomGroup': 'Nous ne pouvons pas créer ce groupe personnalisé.',
	'aria_label_datatable': 'Table de données',
	'summaryCaption': 'Récapitulatif',
	'MeasuresCaption': 'Mesures',
	'MeasuresGroupCaption': 'Groupe de mesures (%{count})',
	'ValuesCaption': 'Valeurs',
	'turnInsightsOn': 'Activer Insights',
	'turnInsightsOff': 'Désactiver Insights',
	'decisionRules': 'Règles',
	'decisionTree': 'Diagramme d\'arbre',
	'decisionSunburst': 'Rayons de l\'arbre',
	'switchToDecisionRules': 'Basculer vers les règles de décision',
	'switchToDecisionTree': 'Basculer vers l\'arbre de décisions',
	'data_group_less_then': 'inférieur à %{rangeTo}',
	'data_group_to': 'Du %{rangeFrom} au < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} et supérieur',
	'nullValueContent': '(pas de valeur)',
	'sum': 'Somme',
	'count': 'Nombre',
	'countdistinct': 'Nombre (éléments distincts)',
	'avg': 'Moyenne',
	'min': 'Minimum',
	'max': 'Maximum',
	'automatic': 'Personnalisé',
	'variance': 'Variance',
	'stddev': 'Ecart type',
	'median': 'Valeur médiane',
	'calculated': 'Valeur calculée',
	'none': 'Aucun',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': 'Valeurs d\'invite',
	'inputLabelPrompt': 'Valeur',
	'inputPlaceholderPrompt': 'Entrez une valeur',
	'inputInvalidText': 'Entrée non valide pour le type %{dataType}',
	'unSupportedPrompt': 'Invite non prise en charge',
	'missingDataSource': 'Impossible de trouver la source de données appropriée.',
	'unSupportedPromptType': 'Le scénario avec invites n\'est pas pris en charge actuellement.',
	'preAggregateLabel': 'Appliquer les valeurs d\'invite de la source de données',
	'postAggregateLabel': 'Appliquer les valeurs d\'invite dans le rapport',
	'preAggregateText': 'La plage utilise les valeurs qui figurent dans la source de données et non les valeurs affichées dans le tableau de bord.',
	'defaultAggregation_count': 'Nombre',
	'defaultAggregation_countdistinct': 'Nombre (éléments distincts)',
	'defaultAggregation_max': 'Maximum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Moyenne',
	'defaultAggregation_sum': 'Somme',
	'defaultAggregation_auto': 'Auto (%{aggregationType})',
	'keydriver_average': 'Moyenne globale',
	'keydriver_up_down': 'Les groupes mis en évidence avec des moyennes élevées ou faibles ont plus d\'impact sur la cible. Les groupes avec des moyennes exceptionnellement élevées ou faibles ont le plus fort impact.',
	'keydriver_different': 'Les groupes mis en évidence ont des distributions qui diffèrent considérablement de la distribution globale. Ces groupes ont plus d\'impact sur la cible.',
	'topOperator': 'En haut',
	'bottomOperator': 'En bas',
	'topBottomFact': '%{operator} %{value}%{percent} par %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Supprimer le nombre de premiers ou de derniers',
	'deleteTopBottomPercent': 'Supprimer le pourcentage de premiers ou de derniers',
	'topBottomTitle': 'Cet objet uniquement',
	'deleteTopBottom': 'Supprimer le nombre de premiers ou de derniers',
	'editTopBottom': 'Editer le nombre de premiers ou de derniers',
	'editTopBottomCount': 'Editer le nombre de premiers ou de derniers',
	'editTopBottomPercent': 'Editer le pourcentage de premiers ou de derniers',
	'ariaDeleteTopBottomCountLabel': 'Appuyez sur la touche SUPPR pour supprimer le nombre de premiers ou de derniers.',
	'ariaDeleteTopBottomPercentLabel': 'Appuyez sur la touche SUPPR pour supprimer le pourcentage de premiers ou de derniers.',
	'ariaEditTopBottomCountLabel': 'Appuyez sur la touche ENTREE pour éditer le nombre de premiers ou de derniers.',
	'ariaEditTopBottomPercentLabel': 'Appuyez sur la touche ENTREE pour éditer le pourcentage de premiers ou de derniers.',
	'ariaDeleteDrillStateLabel': 'Appuyez sur la touche ENTREE pour éditer le nombre de premiers ou de derniers.',
	'drillUpStateTitle': 'Passer au niveau supérieur',
	'drillDownStateTitle': 'Passer au niveau inférieur',
	'ariaEditTopBottomLabel': 'Appuyez sur la touche ENTREE pour éditer le nombre de premiers ou de derniers.',
	'ariaDeleteTopBottomLabel': 'Appuyez sur la touche SUPPR pour supprimer le nombre de premiers ou de derniers.',
	'allKeyDriversLabel': 'Auto (tous les pilotes)',
	'filter_drag_and_drop_single_dock': 'Glissez-déposez des données ici pour filtrer.',
	'filter_drag_and_drop_all_tabs': 'Glissez-déposez des données ici pour filtrer tous les onglets.',
	'filter_drag_and_drop_current_tab': 'Glissez-déposez des données ici pour filtrer cet onglet.',
	'filter_empty_consume_mode': 'Aucun filtre n\'a été appliqué.',
	'filterClearAllItems': 'Effacer tous les filtres',
	'filterDeleteAllItems': 'Supprimer tous les filtres',
	'filterDockChevronLeft': 'Faire défiler les données',
	'filterDockChevronRight': 'Faire défiler les données',
	'filterIconLabel_Single': 'Filtres',
	'filterIconLabel_Global': 'Tous les onglets',
	'filterIconLabel_Tab': 'Cet onglet',
	'filterIconTooltip_Single': 'Filtres',
	'filterIconTooltip_Global': 'Filtres pour tous les onglets',
	'filterIconTooltip_Tab': 'Filtres pour cet onglet',
	'filterDropZoneTooltip_Single': 'Filtrer la zone d\'insertion',
	'filterDropZoneTooltip_Global': 'Filtrer la zone d\'insertion pour tous les onglets',
	'filterDropZoneTooltip_Tab': 'Filtrer la zone d\'insertion pour cet onglet',
	'filterOverflowMenu': 'Plus',
	'expand': 'Développer',
	'collapse': 'Réduire',
	'filterDockItemNameAriaLabel': 'Appuyer sur Entrée pour lancer la boîte de dialogue de filtre et définir le filtre.',
	'filterItemCanvasMove': 'Ajouter au canevas',
	'filterItemDelete': 'Supprimer le filtre',
	'filterInvertRange': 'tout sauf : %{from} à %{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'Pas après %{from}',
	'filter_date_after': 'Après %{from}',
	'filter_date_before_except': 'Pas avant %{to}',
	'filter_date_before': 'Avant %{to}',
	'filter_date_between_except': 'Pas entre %{from} et %{to}',
	'filter_date_between': 'Entre %{from} et %{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Toutes',
	'filter': 'Filtre',
	'filterExcept': 'sauf %{values}',
	'filterDockToolbarButtonLabel': 'Filtrer le dock',
	'navigateTitle': 'Accès à',
	'navigateSelectColumn': 'Sélectionner une colonne',
	'navigateSelectPath': 'Sélectionner un chemin de navigation',
	'current_nav_group': 'Le groupe de navigation en cours est %{navigation_group_name}',
	'next': 'Suivant',
	'previous': 'Précédent',
	'multiselectMsg': '%{count} sélectionné',
	'errMsgFilterItemMissingTitle': 'Les valeurs de filtre %{itemName} ne peuvent pas être chargées car ces valeurs ne sont pas disponibles avec ce fichier',
	'errMsgFilterItemGenericTitle': 'Impossible de charger les valeurs de filtre',
	'textFilterItemsNotFound': 'Aucun élément n\'est disponible.',
	'nullValueLabel': '(blanc)',
	'filterConditionLabel': 'Condition de filtre',
	'filter_includesAll': 'Tout inclure',
	'filter_allMembersOfSet': 'Tous les membres de l\'ensemble',
	'modelFilter': 'Filtre',
	'filtersTitle': 'Propriétés du filtre',
	'search': 'Rechercher',
	'clearTextFilterValue': 'Effacer',
	'invertFilterSelection': 'Inverser',
	'modellingLoading': 'Chargement...',
	'searchAll': 'Rechercher toutes les colonnes',
	'toolbarActionPossibleKeyDrivers': 'Editer la portée',
	'toolbarActionPossibleKeyDriversSubTitle': 'Faites glisser les éléments de gauche pour qu\'ils soient pris en compte dans le graphique d\'analyse des pilotes.',
	'toolbarActionSort': 'Trier',
	'toolbarActionSortAscending': 'Croissant',
	'toolbarActionSortDescending': 'Décroissant',
	'toolbarActionSortAuto': 'Auto (%{sortOrder})',
	'toolbarActionSortCustom': 'Personnalisé',
	'toolbarActionFormat': 'Formater les données',
	'toolbarActionFormatText': 'Formater les données (texte)',
	'toolbarActionFormatAbbreviation': 'Abréger',
	'toolbarActionFormatNone': 'Automatique',
	'toolbarActionFilter': 'Filtre',
	'toolbarActionTopBottom': 'Premier ou dernier',
	'toolbarActionRmvShape': 'Retirer une forme',
	'toolbarActionToggleShapeDrop': 'Forme de l\'infographique',
	'toolbarActionToggleShapeDropTitle': 'Création d\'infographie',
	'toolbarActionToggleShapeDropText': 'Faites glisser une forme dans cette zone pour créer une infographie.',
	'toolbarActionAggregationType': 'Récapituler',
	'toolbarDeleteActionText': 'Retirer la colonne',
	'toolbarTextActionText': 'Texte mis en style',
	'toolbarActionFilterLocalKeepSelected': 'Conserver',
	'toolbarActionFilterLocalExcludeSelected': 'Exclure',
	'toolbarActionFilterAllKeepSelected': 'Filtre',
	'toolbarActionSimpleCalculation': 'Calcul simple',
	'toolbarActionDrillBack': 'Précédent',
	'toolbarActionDrillUp': 'Passer au niveau supérieur',
	'toolbarActionDrillDown': 'Passer au niveau inférieur',
	'toolbarActionJumpTo': 'Explorer',
	'toolbarActionNavigate': 'Naviguer',
	'toolbarActionCreateFilterGroup': 'Créer une connexion',
	'toolbarActionDisconnectFilterGroup': 'Rompre tous les liens',
	'toolbarActionLinkFilterGroup': 'Ajouter à une connexion existante',
	'toolbarActionLassoSelect': 'Sélectionner l\'outil',
	'toolbarActionRefreshDeveloperWidget': 'Actualiser',
	'textFontFamilySubClassHairline': 'Trait fin',
	'textFontFamilySubClassThin': 'Fin',
	'textFontFamilySubClassThinItalic': 'Italique fin',
	'textFontFamilySubClassExtraLight': 'Extra-fin',
	'textFontFamilySubClassExtraLightItalic': 'Italique extra-fin',
	'textFontFamilySubClassLight': 'Fin',
	'textFontFamilySubClassLightItalic': 'Italique fin',
	'textFontFamilySubClassRegular': 'Normal',
	'textFontFamilySubClassRegularItalic': 'Italique normal',
	'textFontFamilySubClassItalic': 'Italique',
	'textFontFamilySubClassMedium': 'Moyen',
	'textFontFamilySubClassMediumItalic': 'Italique moyen',
	'textFontFamilySubClassHeavy': 'Epais',
	'textFontFamilySubClassHeavyItalic': 'Italique épais',
	'textFontFamilySubClassDemiBold': 'Demi-gras',
	'textFontFamilySubClassDemiBoldItalic': 'Italique demi-gras',
	'textFontFamilySubClassBold': 'Gras',
	'textFontFamilySubClassBoldItalic': 'Italique gras',
	'textFontFamilySubClassExtraBold': 'Extra-gras',
	'textFontFamilySubClassExtraBoldItalic': 'Italique extra-gras',
	'textFontFamilySubClassBlack': 'Noir',
	'textFontFamilySubClassBlackItalic': 'Italique noir',
	'textFontFamilySubClassStencil': 'Stencil',
	'dlg_ascending': 'croissant',
	'dlg_descending': 'décroissant',
	'dlg_custom': 'personnalisé',
	'dlg_none': 'aucun',
	'dlg_hierarchy': 'hiérarchie',
	'dlg_namedSet': 'ensemble nommé',
	'dlg_rank': 'rank',
	'visualizationLabel': 'Visualisation',
	'chartLabel': 'Graphique %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Appuyez sur F12 pour naviguer à l\'intérieur du widget',
	'f10KeyDescription': 'Appuyez sur F10 pour lancer la vue de mise en évidence du widget',
	'playButtonLabel': 'Lire',
	'dataPlayerValueListLabel': 'Valeurs de lecteur de données',
	'localFilterTitle': 'Cet objet uniquement',
	'globalFilterTitle': 'Tous les objets',
	'deleteFilter': 'Supprimer le filtre',
	'editFilter': 'Editer le filtre',
	'ariaEditFilterLabel': 'Appuyez sur la touche Entrée pour éditer le filtre.',
	'ariaDeleteFilterLabel': 'Appuyez sur la touche Suppr pour supprimer le filtre.',
	'measureFilterBetween': 'Entre %{lowerBound} et %{upperBound}',
	'measureFilterNotBetween': 'Pas entre %{lowerBound} et %{upperBound}',
	'dimFilterIn': 'Inclut : %{in}',
	'dimFilterNotIn': 'Exclut : %{out}',
	'gtFilter': 'Après %{lowerBound}',
	'ltFilter': 'Avant %{upperBound}',
	'ariaEditPrompt': 'Appuyez sur la touche Entrée pour changer la valeur d\'invite',
	'dataPointFilterTitle': 'Points de données',
	'dataPointFilterIncludeSummary': 'Points de données %{valueCount} inclus',
	'dataPointFilterExcludeSummary': 'Points de données %{valueCount} exclus',
	'widgetFiltersLabel': 'Filtres de widget',
	'coachMarkTitleSpiralTarget': 'Editer la portée',
	'coachMarkContentSpiralTarget': 'Vous pouvez accéder ici au pilote sélectionné pour votre cible et le modifier.',
	'srILVTreeLabel': 'Liste',
	'geomapUnrecognizedLocations': 'Emplacements non reconnus :',
	'geomapAmbiguousLocations': 'Régions ambiguës :',
	'visualizationNotifications': 'Notifications de visualisation :',
	'dataNotifications': 'Notifications de données :',
	'autobinSuggestion': 'Activer le regroupement automatique',
	'LIVE_empty_visualization_hint_title': 'Générez votre visualisation',
	'LIVE_empty_visualization_hint_description': 'Glissez les données ici ou sur les zones.',
	'LIVE_slots_required_field_description': '%{asterisk} Indique une zone requise',
	'LIVE_slots_drag_and_drop_description': 'Glissez-déposez des données sur les zones ci-dessus pour générer et filtrer la visualisation.',
	'dwErrorLoadingAvailableVisualizations': 'Impossible de charger les définitions de visualisation disponibles.',
	'moreDataIndicator': 'Vos données ont été tronquées à %{threshold} éléments. Appliquez un filtre pour en afficher moins.',
	'nonCtxTopBottomInvalid': 'La définition d\'une règle supérieure ou inférieure sans contexte n\'est pas prise en charge pour les tableaux croisés. Elle a été supprimée de cette vue de tableau croisé.  Redéfinissez la règle sur une ou plusieurs catégories dans le contexte de %{columnName}.',
	'dwErrorLoadingVisualizationNotFound': 'Impossible de charger l\'objet, car il lui manque une définition de visualisation.',
	'dwErrorLoadingVisualizationListNotFound': 'Impossible de charger la visualisation.',
	'dwErrorRunningQuery': 'Impossible d\'extraire les données de l\'ensemble de données %{datasetName}.',
	'dwErrorGeoData': 'L\'affichage des données géographiques dans une carte ne fonctionne pas bien. Veuillez choisir un autre type de visualisation.',
	'dwPromptSignonCancelWarning': 'Les données pour cette visualisation ne sont pas disponibles. Indiquez les données d\'identification appropriées.',
	'dwErrorMissingDataset': 'Impossible de charger la visualisation car l\'ensemble de données "%{datasetName}" qui lui est associé n\'est pas disponible.',
	'dwErrorRenderingVisualization': 'Impossible de charger cette visualisation.',
	'dwErrorVisualizationTooSmall': 'La visualisation est trop petite pour afficher les données qu\'elle contient. Agrandissez la visualisation ou réduisez les données qu\'elle contient.',
	'errorSourceNotFound': 'Impossible de charger la visualisation car l\'ensemble de données "%{sourceName}" qui lui est associé n\'est pas disponible.',
	'errorActionNotSupported': 'Cette action n\'est pas prise en charge pour la source de données "%{sourceName}".',
	'errorMeasureNotSupportedOnMultiEdges': 'La visualisation comporte des mesures sur plusieurs périphéries, ce qui n\'est plus pris en charge. Placez les mesures sur une seule arête.',
	'errorExceedAllowableValue': 'Le nombre estimé de cellules dépasse la valeur admissible de 100000. Veuillez appliquer un filtrage aux ensembles projetés pour réduire le nombre de cellules.',
	'propScaleLabel': 'Nombre d\'icônes',
	'propScaleDescription': 'Sélectionnez le nombre d\'icônes',
	'propScaleFew': 'Faible',
	'propScaleDefault': 'Par défaut',
	'propScaleMany': 'Elevé',
	'lastRefresh': 'Dernière actualisation : il y a %{timeInterval}',
	'widgetTimer': 'Temporisateur de widget',
	'datasetItemsUnavailable': 'Certains éléments de l\'ensemble de données utilisés dans cette visualisation sont indisponibles.',
	'datasetItemUnavailable': 'Cet élément d\'ensemble de données n\'est pas disponible',
	'retry': 'Réessayer',
	'widgetConditionalFormatLabel': 'Activer/Désactiver les contrôles de formatage conditionnel',
	'widgetConditionalFormatTitle': 'Editer la couleur du formatage conditionnel',
	'crosstabName': 'Tableau croisé',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'Non disponible',
	'summaryLabel': '%{label} avec la valeur %{value}',
	'infographicLabel': '%{label} avec la valeur %{value}',
	'warning': 'Avertissement',
	'swapRowsAndColumns': 'Permuter les lignes et les colonnes',
	'hideSummariesLabel': 'Masquer les récapitulatifs',
	'showSummariesLabel': 'Afficher les récapitulatifs',
	'hideRowColumn': 'Masquer',
	'showAllRowColumn': 'Afficher tout',
	'dataAssetPropertiesLabel': 'Propriétés de visualisation',
	'evAdd': 'Ajouter une colonne',
	'evCollapse': 'Réduire',
	'evColumns': 'Colonnes',
	'evLocalFilters': 'Filtres locaux',
	'evExpand': 'Développer',
	'evFilterTooltip': 'Filtre',
	'missingColumn': 'Manquant : %{columnLabel}',
	'missingFiltering': 'Filtres manquants pour les colonnes :',
	'missingDataItem': 'La donnée élémentaire "%{dataItemId}" référencée est introuvable dans le widget.',
	'heatByLabel': 'Densité selon',
	'toolbarChangeVisualization': 'Changer de visualisation',
	'modellingRelatedTablesNoneFound': 'Aucune table associée n\'a été trouvée',
	'processing': 'Traitement...',
	'errorCellWarning': 'Certaines valeurs récapitulatives n\'ont pas pu être calculées.',
	'aggregateTypeToggler': 'Afficher le type d\'agrégation',
	'maxColumnsExceeded': 'Dépassement du nombre maximum de colonnes. %{columns} supprimé.',
	'unboundColumns': 'Impossible d\'utiliser les colonnes suivantes : %{columns}.',
	'unboundColumn': 'Impossible d\'utiliser la colonne suivante : %{columns}.',
	'recommendRequestFailed': 'Echec de la demande de recommandation. Contactez votre administrateur.',
	'visualizationDoesNotSupportOLAP': 'Nous ne pouvons pas créer cette visualisation basée sur une source de données OLAP. Utilisez une autre source de données prise en charge.',
	'showDataBehindVizLabel': 'Afficher les données',
	'showDataBehindVizNotSupportedLabel': 'L\'affichage des données n\'est pas pris en charge pour ce type de visualisation',
	'exploreData': 'Explorer...',
	'newExplore': 'Nouvelle exploration',
	'thumbnails_error_fetching': 'Erreur lors de la récupération des miniatures',
	'loadedThumbnailImage': 'Image miniature de visualisation %{visType} chargée',
	'autobinAxisLabel': 'groupes',
	'recommended_visualizations': 'Visualisations recommandées',
	'all_visualizations': 'Toutes les visualisations',
	'edit': 'Editer',
	'selectTargetDialogTitle': 'Sélectionner une cible d\'accès au détail',
	'noTargetInCM': 'Impossible de trouver la cible d\'accès au détail',
	'errorDrillDefinition': 'Un problème s\'est produit lors de l\'ajout ou de la modification de la définition d\'exploration transversale.',
	'errorDrillToTarget': 'Une erreur est survenue lors de l\'exploration de "%{targetName}"',
	'drillThroughMappingViewLabel': 'Affecter des colonnes de votre tableau de bord aux invites du rapport cible',
	'drillthroughScopeRadioLabel': 'Appliquer cette définition à :',
	'drillthroughScopeRadioOptionVisualization': 'Cette visualisation uniquement',
	'drillthroughScopeRadioOptionConnection': 'Les visualisations dans la même connexion qui utilisent la même source de données',
	'drillthroughScopeRadioOptionDashboard': 'Toute visualisation sur le %{perspective} qui utilise la même source de données',
	'drillThroughParametersColumnTitle': 'Invites "%{targetName}" :',
	'drillThroughMetadataColumnTitle': 'Colonnes de données "%{boardName}" :',
	'drillThroughDefinitionNoParameter': 'La cible d\'accès au détail n\'a aucune invite.',
	'drillThroughDefinitionErrorQueryingReport': 'Corrigez le problème lié au rapport cible, puis réessayez pour créer la définition d\'accès au détail.',
	'drillThroughDefinitionErrorDlgTitle': 'Un problème s\'est produit',
	'dlg_back': 'Revenir en arrière',
	'dlg_close': 'Fermer',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Annuler',
	'dlg_apply': 'Appliquer',
	'dlg_create': 'Créer',
	'dlg_done': 'Terminé',
	'drillthrough_unsaveMsg': 'Voulez-vous poursuivre sans sauvegarder "%{name}" ?',
	'drillthrough_jumpTo': 'Définition d\'accès au détail : %{name}',
	'drillthrough_jumpToLabel': 'Explorer',
	'drillthrough_manage': 'Gérer...',
	'drillthrough_addNewTarget': 'Ajouter une nouvelle définition d\'accès au détail',
	'drillthrough_manageJumpPaths': 'Gérer les définitions d\'accès au détail',
	'drillthrough_manageJumpPaths_edit': 'Editer "%{name}"',
	'drillthrough_manageJumpPaths_delete': 'Supprimer "%{name}"',
	'drillthrough_manageAddAnotherTarget': 'Ajouter une autre définition d\'accès au détail',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Confirmer la suppression',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Voulez-vous vraiment supprimer l\'accès au détail "%{name}" ?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Nom d\'accès au détail en double',
	'drillthrough_definitionMessage': 'L\'accès au détail "%{name}" existe déjà. Indiquez un autre nom.',
	'drillthrough_jumpToTarget_notFound': 'Cible non trouvée pour l\'accès au détail "%{name}"',
	'drillThroughDefinitionNoParameterSubTitle': 'Aucun contexte ne sera transmis au rapport cible.',
	'drillthrough_titleLabel': 'Nom',
	'drillthrough_create_dialogTitle': 'Créer une définition d\'accès au détail',
	'drillthrough_edit_dialogTitle': 'Editer la définition d\'accès au détail',
	'drillthrough_subTitle': 'Le contexte de la visualisation dans votre source est utilisé pour filtrer la cible %{perspective}.',
	'drillthrough_selectColumn': 'Sélectionner une colonne',
	'noPrompt': 'Aucune invite',
	'promptDialog': 'Boîte de dialogue %{promptType}',
	'formatAutoDescription': 'Auto indique le format hérité de votre source de données ou visualisation',
	'formatDefaultDescription': 'La valeur par défaut indique le format hérité du système',
	'createCustomGroupAction': 'Créer le groupe de données',
	'removeCustomGroupAction': 'Retirer le groupe de données',
	'editCustomGroupAction': 'Editer le groupe de données',
	'renameCustomGroupAction': 'Renommer le groupe de données',
	'createCustomGroupErrorToast': 'Votre groupe de données n\'a pas pu être créé.',
	'removeCustomGroupErrorToast': 'Votre groupe de données n\'a pas pu être supprimé.',
	'editCustomGroupErrorToast': 'Votre groupe de données n\'a pas pu être édité.',
	'renameCustomGroupErrorToast': 'Votre groupe de données n\'a pas pu être renommé.',
	'customGroupLabel': 'Créer le groupe de données',
	'ungroupCustomGroupLabel': 'Dégrouper',
	'renameCustomGroupLabel': 'Renommer',
	'createCustomGroupLabel': 'Créer',
	'customGroupingLabel': '%{columnLabel} (Groupe)',
	'createCustomSort': 'Créer un tri personnalisé',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': 'Sélectionnez les éléments disponibles, puis réorganisez-les pour créer un tri personnalisé.',
	'availableItems': 'Eléments disponibles',
	'selectAll': 'Tout sélectionner',
	'customSortOrder': 'Ordre de tri personnalisé',
	'selectAvailableItemsDesc': 'Sélectionnez les éléments disponibles, puis réorganisez-les.',
	'moveToTop': 'Déplacer vers le haut',
	'clear': 'Effacer',
	'sortRemainingItemsBy': 'Trier les éléments restants par',
	'removeAll': 'Retirer tout',
	'resetTooltip': 'Tous les éléments seront supprimés de la liste %{customSortOrder} et la liste déroulante %{sortRemainingItemsBy} sera réinitialisée.',
	'manyItemsWarning': 'La sélection d\'un grand nombre d\'éléments peut avoir un impact sur les performances de votre tableau de bord.',
	'manyItemsSelected': 'Plusieurs éléments %{maxItems} ont été sélectionnés ; cela peut avoir un impact sur les performances de votre tableau de bord.',
	'somethingWentWrong': 'Oups. Un problème est survenu.',
	'tryAgain': 'Réessayer',
	'customSortLabel': 'Tri personnalisé',
	'applyError': 'Impossible d\'appliquer %{action}.',
	'searchReturnedNoResults': 'Votre recherche n\'a renvoyé aucun résultat.',
	'extVisSystem': 'Système',
	'extVisCustom': 'Personnalisé',
	'customVisTestVisualization': 'Visualisation des tests',
	'extVisCustomVisPreview': 'aperçu',
	'extVisCustomPreviewWidgets': 'Widgets de développeur',
	'extVisCustomVVisualization': 'Visualisation',
	'extVisCustomVisuals': 'Visuels personnalisés',
	'noPermissionToManage': 'Les droits qui vous sont attribués ne vous permettent pas de gérer les visualisations personnalisées.',
	'extVisCustomUpdate': 'Mettre à jour',
	'extVisCustomDelete': 'Supprimer',
	'extVisNoCustomVisuals': 'Aucun visuel personnalisé',
	'extVisNoCustomVisualsMsg': 'Il n\'existe actuellement aucun visuel personnalisé dans votre organisation',
	'extVisAddCustomVisual': 'Ajouter un visuel personnalisé',
	'extVisNoCustomVisualsAdminMsg': 'Il n\'existe actuellement aucun visuel personnalisé. Ajoutez-en un pour commencer',
	'extVisNoSDKConnection': 'Aucune connexion avec votre fichier local n\'a été créée',
	'extVisNoSDKPreviewMsg': 'Pour avoir un aperçu de vos visualisations, établissez une connexion.',
	'extVisMore': 'Plus',
	'extVisDeleteDialogTitle': 'Supprimer un visuel personnalisé',
	'extVisDeleteDialogBody': 'Voulez-vous vraiment supprimer cette visualisation personnalisée ? Elle est peut-être utilisée par d\'autres tableaux de bord et rapports.',
	'extVisDeleteConfirmation': 'Votre visuel personnalisé a été supprimé.',
	'extVisDeleteError': 'Impossible de supprimer votre visuel personnalisé. %{msg}',
	'extVisCloseToast': 'Fermer maintenant',
	'extVisAdd': 'Votre visuel personnalisé a été ajouté.',
	'extVisAddError': 'Impossible d\'ajouter votre visuel personnalisé. %{msg}',
	'extVisUpdate': 'Votre visuel personnalisé a été mis à jour.',
	'extVisUpdateError': 'Impossible de mettre à jour votre visuel personnalisé. %{msg}',
	'extVisAddProgress': 'Importation de %{name}',
	'extVisUpdateProgress': 'Mise à jour de %{name}',
	'extPermissionTitle': 'Accès restreint ou visuel personnalisé supprimé',
	'extPermissionBody': 'Ce visuel personnalisé ne peut pas être affiché car il a été supprimé ou son accès est restreint.',
	'customVizSaveWarning': 'Impossible de sauvegarder vos visuels personnalisés. Ils n\'ont pas été importés.',
	'schematicTestCaption': 'Tester le schéma',
	'schematicServiceRequestError': 'Erreur du service de schéma',
	'extVisPreviewMessage': 'Il s\'agit d\'un aperçu. La visualisation n\'a pas encore été ajoutée au produit.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Non défini',
	'kpiDefaultTargetLabel': 'Cible',
	'kpiNonNumericTarget': 'La valeur cible doit être un nombre.',
	'kpiManualTargetSlotFilled': 'Valeur appliquée dans la zone',
	'kpiAutoValueSize': 'Automatique',
	'kpiUnableDrawSparklineLabel': 'Impossible de dessiner le graphique sparkline',
	'kpiUnableDrawSparklineInfo': 'Un graphique sparkline nécessite au minimum deux points de cohérence. Modifiez les données ou ajustez les filtres afin d\'afficher le graphique sparkline.',
	'conditionalFormattingTextColor': 'Couleur du texte',
	'suppression': 'Suppression',
	'suppressNone': 'Aucun',
	'suppressRowsAndColumns': 'Lignes et colonnes',
	'suppressRows': 'Lignes',
	'suppressColumns': 'Colonnes',
	'enableSuppression': 'Activer la suppression',
	'disableSuppression': 'Désactiver la suppression',
	'loadVisDefinitionError': 'Impossible de charger la définition pour la visualisation %{id}',
	'emptyVisualization': 'Visualisation vude',
	'expandCollapse': 'Développer et réduire',
	'expandBtnLabel': 'Développer',
	'collapseBtnLabel': 'Réduire',
	'prop_sizeInputNonNumericValue': 'Il doit s\'agir d\'un nombre.',
	'prop_sizeValueShouldBeHigher': 'La valeur doit être supérieure à %{value}.',
	'fontPropLabel': 'Famille de polices',
	'fontSizePropLabel': 'Taille de la police',
	'sectionItemAxisTitle': 'Titre d\'axe de l\'élément',
	'sectionItemAxisLabel': 'Libellé d\'axe de l\'élément',
	'sectionValueAxisTitle': 'Titre d\'axe de la valeur',
	'sectionValueAxisLabel': 'Libellé d\'axe de la valeur',
	'styletext-widget.legend': 'Légende',
	'styletext-itemAxis.ticks.labels': 'Libellés des axes',
	'styletext-valueAxis.title': 'Titres des axes',
	'styletext-itemAxis.title': 'Titres des axes',
	'styletext-labels': 'Libellés de données',
	'styletext-valueAxis.line.title': 'Titres des lignes',
	'styletext-cellValue': 'Valeurs',
	'styletext-values': 'Valeurs',
	'styletext-rowHeading': 'En-têtes de ligne',
	'styletext-columnHeading': 'En-têtes de colonne',
	'fontFamily': 'famille',
	'fontSize': 'taille',
	'visExportFileName': 'Visualisation',
	'ds-missingDataSet': 'Impossible de trouver le fichier. Veuillez vérifier que l\'ensemble de données a été créé.',
	'ds-missingDashboardId': 'Veuillez sauvegarder le tableau de bord avant de créer l\'ensemble de données.',
	'ds-unsupportedDataSourceType': 'Le type de source de données %{type} n\'est pas pris en charge.',
	'dataCache': 'Cache de données',
	'dataCache_on': 'Activé',
	'dataCache_off': 'Aucune mémoire cache',
	'dataCache_auto': 'Automatique',
	'queryOptimization': 'Optimisation de requête'
});
